module.exports = __webpack_public_path__ + "assets/2ad349208b3a727abb3c9f943865a27c.js";